export enum ToastEventType {
    Success = 'success',
    Info = 'info',
    Warning = 'warning',
    Error = 'error',
    ErrorAlert = 'errorAlert'
}